/* eslint-disable camelcase */
// eslint-disable-next-line prettier/prettier
export const contribution_admin_member_frontend_version = '0.1.0';
